/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_PowerInputs */

const en_ui_color_by_power = /** @type {(inputs: Ui_Color_By_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power`)
};

const de_ui_color_by_power = /** @type {(inputs: Ui_Color_By_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung`)
};

/**
* | output |
* | --- |
* | "Power" |
*
* @param {Ui_Color_By_PowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_power = /** @type {((inputs?: Ui_Color_By_PowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_PowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_power(inputs)
	return de_ui_color_by_power(inputs)
});